var _style, _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _polygon, _polygon2, _polygon3, _path120, _polygon4, _polygon5, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _polygon6, _path151, _path152, _path153, _path154;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg21(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#17243F;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{fill:url(#SVGID_4_);}\r\n\t.st6{fill:url(#SVGID_5_);}\r\n\t.st7{fill:url(#SVGID_6_);}\r\n\t.st8{fill:url(#SVGID_7_);}\r\n\t.st9{fill:url(#SVGID_8_);}\r\n\t.st10{fill:#EBF5FB;}\r\n\t.st11{fill:#395E68;}\r\n\t.st12{fill:url(#SVGID_9_);}\r\n\t.st13{fill:url(#SVGID_10_);}\r\n\t.st14{fill:url(#SVGID_11_);}\r\n\t.st15{fill:url(#SVGID_12_);}\r\n\t.st16{fill:#00A7D0;}\r\n\t.st17{fill:url(#SVGID_13_);}\r\n\t.st18{fill:url(#SVGID_14_);}\r\n\t.st19{fill:url(#SVGID_15_);}\r\n\t.st20{fill:#C3E4EF;}\r\n\t.st21{fill:#D6ECF3;}\r\n\t.st22{fill:#E2F0F6;}\r\n\t.st23{fill:#A9C2CD;}\r\n\t.st24{fill:#B3C6CF;}\r\n\t.st25{fill:#9BBECA;}\r\n\t.st26{fill:url(#SVGID_16_);}\r\n\t.st27{fill:#7CCDF3;}\r\n\t.st28{fill:url(#SVGID_17_);}\r\n\t.st29{fill:url(#SVGID_18_);}\r\n\t.st30{fill:url(#SVGID_19_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30,
    cy: 30,
    r: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.8,45.2H20.6c-1.3,0-2.3-0.7-2.3-1.8v1.8c0,2.3,1.8,4.2,4.1,4.2c0,0,0.1,0,0.1,0h13.6 c2.3,0.1,4.3-1.8,4.3-4.1c0,0,0,0,0,0v-1.8C40.5,44.4,39.1,45.2,37.8,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1,13.1H22.6c-2.4,0.1-4.3,2-4.3,4.4v2c0.1-1.2,1.1-2.1,2.3-2h17.2c1.3,0,2.7,1,2.7,2v-2 C40.5,15.2,38.5,13.2,36.1,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.8,46H20.6c-1.6,0.1-3-1-3.1-2.6V19.6c0.2-1.6,1.6-2.7,3.1-2.6h17.2c1.6,0,3.4,1,3.4,2.6v23.8 C41.2,45,39.4,46,37.8,46z M20.6,18.4c-0.9,0-1.6,0.5-1.6,1.1v23.8c0,0.6,0.8,1.1,1.6,1.1h17.2c1,0,1.9-0.6,1.9-1.1V19.6 c0-0.5-0.9-1.1-1.9-1.1H20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1,50.2H22.6c-2.8,0-5-2.2-5-5V17.6c0-2.8,2.2-5,5-5h13.6c2.8,0,5,2.2,5,5v27.6 C41.2,47.9,38.9,50.2,36.1,50.2C36.2,50.2,36.2,50.2,36.1,50.2z M22.6,14c-2,0-3.6,1.6-3.6,3.6c0,0,0,0,0,0v27.6 c0,2,1.6,3.6,3.6,3.6h13.6c2,0,3.6-1.6,3.6-3.6V17.6c0-2-1.6-3.6-3.6-3.6H22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.9,15.8h-1.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.7c0.3,0,0.5,0.2,0.5,0.5S30.1,15.8,29.9,15.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.4797,
    y1: 52.9452,
    x2: 50.41,
    y2: 52.9452,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.2,12.6c-0.4,0-0.7-0.3-0.7-0.6c-0.1-0.4,0.2-0.8,0.6-0.9c0.7-0.1,1.4-0.6,1.8-1.2l0.2-0.4 c0.4-0.7,0.7-1.6,0.8-2.4c0.1-0.9,0.9-1.6,1.8-1.6c1.2,0,2.1,0.9,2.2,2.1c0,0,0,0,0,0.1c0.1,1.1,0,2.2-0.4,3.2h2.3 c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7l0,0h-4.3l0.3-1c0.4-1.1,0.6-2.3,0.6-3.6c0-0.3-0.2-0.8-0.5-0.8 c-0.2,0-0.3,0-0.4,0.2c-0.1,1.1-0.4,2.1-0.9,3l-0.2,0.4c-0.6,1.1-1.7,1.8-2.9,2.1L41.2,12.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.7,
    y1: 49.0294,
    x2: 52.18,
    y2: 49.0294,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.2,15.1h-0.4c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7H50c0.4,0,0.4,0,0.6-0.1 c0.1-0.2,0.1-0.5,0.1-0.7c0-0.2-0.2-0.3-0.3-0.3c-0.3,0-0.6,0-0.9,0l0,0c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 c0,0,0,0,0,0c0.4-0.1,0.8-0.1,1.2,0c0.7,0.2,1.2,0.7,1.4,1.4c0.2,0.7,0,1.5-0.5,2.1C51.3,14.9,50.7,15.1,50.2,15.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.5293,
    y1: 45.9749,
    x2: 51.6693,
    y2: 45.9749,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.8,17.4h-0.2c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8-0.3-0.8-0.7c0,0,0,0,0,0c0-0.4,0.3-0.7,0.7-0.8h0.4 c0.4,0,0.4,0,0.5-0.1c0.1-0.1,0.1-0.2,0.1-0.3c-0.1-0.4,0.2-0.8,0.6-0.8c0.4-0.1,0.8,0.2,0.8,0.6c0.1,0.6-0.1,1.1-0.5,1.6 C50.8,17.2,50.3,17.4,49.8,17.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.9894,
    y1: 43.4453,
    x2: 51.1413,
    y2: 43.4453,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.3,19.9H49c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8-0.3-0.8-0.7s0.3-0.8,0.7-0.8l0,0c0.2,0,0.3,0,0.4,0 c0.4,0,0.4,0,0.5-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.4,0.3-0.8,0.7-0.8c0,0,0,0,0,0c0.4,0,0.8,0.3,0.8,0.7c0.1,0.5-0.1,1.1-0.5,1.5 C50.3,19.7,49.8,19.9,49.3,19.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.5306,
    y1: 41.3812,
    x2: 50.6106,
    y2: 41.3812,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.8,21.8h-7.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.3c0.4,0,0.4,0,0.5-0.1 c0-0.1,0.1-0.1,0.1-0.2c0-0.4,0.4-0.7,0.8-0.7c0.4,0,0.7,0.4,0.7,0.8c0,0,0,0.1,0,0.1c0,0.4-0.2,0.8-0.5,1.1 C49.8,21.7,49.3,21.9,48.8,21.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.71,
    y1: 50.37,
    x2: 48.3006,
    y2: 50.37,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M47.6,12.4h-2.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h2.1c0.4,0,0.7,0.3,0.7,0.7 C48.3,12,48,12.4,47.6,12.4C47.6,12.4,47.6,12.4,47.6,12.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.4349,
    y1: 45.42,
    x2: 41.6349,
    y2: 45.42,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M40.5,21.9h-3.9c-0.7-0.1-1.2-0.7-1.2-1.4c0,0,0,0,0,0v-8c-0.1-0.7,0.5-1.3,1.2-1.4c0,0,0,0,0,0h3.8 c0.7,0.1,1.2,0.7,1.2,1.4c0,0,0,0,0,0v8C41.7,21.3,41.2,21.9,40.5,21.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.32,
    y1: -134.475,
    x2: 35.12,
    y2: -134.475,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.3,
    y: 37.8,
    className: "st9",
    width: 0.8,
    height: 1.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M31.6,41L31.6,41L31.6,41z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M27.1,41L27,40.8L27.1,41z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M27.3,41.1l0.1,0.1L27.3,41.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M27.2,41l0.1,0.1L27.2,41z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M26.9,40.7l0.1,0.1L26.9,40.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M31.7,40.8L31.7,40.8L31.7,40.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M31.8,40.7C31.8,40.7,31.8,40.7,31.8,40.7C31.8,40.7,31.8,40.7,31.8,40.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.1,29.9L32.1,29.9L32.1,29.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.2,30L32.2,30z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.1,29.9L32.1,29.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.8,30.5L32.8,30.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.6,30.4L32.6,30.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.6,30.3L32.6,30.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.5,30.3L32.5,30.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.7,30.5L32.7,30.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.7,30.5L32.7,30.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.7,30.4L32.7,30.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.4,30.2l0.1,0.1L32.4,30.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.3,30.1L32.3,30.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.2,30L32.2,30L32.2,30z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.8,30.5L32.8,30.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.3,30.1L32.3,30.1L32.3,30.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.02,
    y1: -128.4423,
    x2: 38.14,
    y2: -128.4423,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M32.6,30.7c0.6,1.2,1,2.5,1.2,3.9c0,0,0.1,0.3-0.4,0.2l0.4,0.1c0.1,0,0.3,0,0.3-0.2l0,0 c-0.1,0-0.2-0.2-0.2-0.5c-0.2-1-0.5-2-0.9-3c-0.2-0.4-0.5-0.8-0.9-1.1c-0.1,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0,0.2 C32.2,30.4,32.4,30.5,32.6,30.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.32,
    y1: -128.4742,
    x2: 37.85,
    y2: -128.4742,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M33.5,34.8c0.5,0.1,0.4-0.2,0.4-0.2c-0.2-1.3-0.7-2.6-1.2-3.9c-0.2-0.2-0.4-0.4-0.6-0.6L32,30.7 c0.5,1.1,1.1,2.7,0.5,3.4c0,0-0.2,0.2-1.1,0.1l0,0L33.5,34.8L33.5,34.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.04,
    y1: -128.405,
    x2: 38.14,
    y2: -128.405,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M32,30c0,0.1,0.1,0.1,0.2,0.2c0.4,0.3,0.7,0.7,0.9,1.1c0.3,1,0.6,2,0.9,3c0,0.3,0.1,0.4,0.2,0.5l0,0 c0-0.1,0-0.2-0.1-0.4c-0.1-0.6-0.4-1.6-0.7-2.4c-0.1-0.4-0.3-0.8-0.4-1.2c-0.1-0.1,0,0-0.2-0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1-0.1l0,0l0,0l0,0v0l0,0h0l0,0l0,0l0,0l0,0l0,0l0,0L32,30z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.33,
    y1: -128.5054,
    x2: 36.7208,
    y2: -128.5054,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M32.5,34.2c0.6-0.8,0-2.3-0.5-3.5c-0.2,1.6-0.5,3-0.6,3.6C32.2,34.4,32.5,34.2,32.5,34.2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M31.1,37.8L31.1,37.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M31,37.8L31,37.8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M30.9,37.8L30.9,37.8L30.9,37.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M27.4,37.8L27.4,37.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.46,
    y1: -134.715,
    x2: 34.38,
    y2: -134.715,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M27.6,37.8L27.6,37.8v0.1V38l0,0c0,0,0,0,0,0.1l0,0c0,0,0,0,0,0.1l0,0c0,0,0,0,0,0.1l0,0c0,0,0,0.1,0,0.1 l0,0v0.3c0,0,0,0,0,0.1l0,0l0,0l0,0v0l0,0l0,0l0,0l0,0l0,0v0l0,0l0.1,0.1c-0.1-0.2-0.1-0.5,0-0.7c-0.1,0.5,0.8,0.8,1.1,1.1 c0.3,0.2,0.5,0.5,0.6,0.8c0.2-0.4,0.3-0.8,0.4-1.3c0.1,0.1,0.2,0.1,0.3,0.1c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0-0.1v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0-0.1l0,0v-0.1l0,0v-0.1v-0.1l0,0v-0.1l0,0v-0.1l0,0c0,0,0,0,0-0.1l0,0c0,0,0,0,0-0.1v-0.1l0,0h-0.3 l0,0c-0.2,0-0.5,0-0.7-0.1c-0.2,0.1-0.4,0.1-0.7,0.1l0,0c-0.8,0-0.9-0.2-0.9-0.2c0-0.1,0-0.2,0-0.3c-0.1,0-0.3,0-0.4,0h0.1 L27.6,37.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M30.9,37.8L30.9,37.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M30.9,38"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M30.4,38.2L30.4,38.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.9159,
    y1: -136.89,
    x2: 36.5059,
    y2: -136.89,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M25.9,39.4L25.9,39.4L25.9,39.4L25.9,39.4L25.9,39.4C25.9,39.4,25.9,39.4,25.9,39.4L25.9,39.4L25.9,39.4 L25.9,39.4L25.9,39.4L25.9,39.4L25.9,39.4c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0.1,0,0.1v0.2l0,0v0.1l0,0l0,0l0,0l0,0v0.1 c0.1,0.3,0.3,0.6,0.5,0.9l0.1,0.1l0,0l0.1,0.1l0,0l0.1,0.1l0,0L27,41l0,0l0.1,0.1h0l0.4,0.3c0.2,0.2,0.3,0.4,0.5,0.6 c0-0.1-0.1-0.3-0.1-0.4c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.3,0.2,0.5,0.2,0.8c0,0.5,0.3,1,0.7,1.3c0.1-0.4,0.2-0.7,0.4-1 c0.2-0.3,0.5-0.6,0.7-0.9c0.4-0.6,0.6-1.3,0.5-2.1c0.1,0.4,0.1,0.9,0,1.3c-0.2,0.4-0.2,0.8-0.3,1.2c0-0.2,0.1-0.4,0.2-0.6 c0.3-0.3,0.6-0.7,0.9-1l0.1-0.1l0,0l0-0.1l0,0c0,0,0,0,0-0.1v-0.1c0.3-0.6,0.4-1.2,0.2-1.9c0.2,0.1,0.1,0.7,0.4,0.7 c-0.1-0.3,0-0.7-0.1-1c0-0.2-0.1-0.3-0.2-0.5C32,38,32,37.9,31.9,37.8c-0.2,0.1-0.5,0.2-0.8,0.2h0.1c0,0.1,0.1,0.2,0.1,0.2 c0.1,0.4,0.2,0.8,0.1,1.1c0,0.3-0.1,0.6-0.3,0.8c-0.1,0.2-0.2,0.3-0.2,0.5c-0.2-0.1-0.2-0.5-0.3-0.7c-0.1-0.2-0.2-0.4-0.3-0.5 c0.1,0.5,0,1.1-0.3,1.5c-0.2,0.5-0.6,1-1,1.3c0-0.5-0.6-1-0.9-1.3c-0.2-0.2-1-0.8-1-1.1c0,0.3,0,0.5,0.2,0.8 c-0.4-0.3-0.6-0.8-0.6-1.4c0-0.5,0.1-0.9,0.4-1.3l0,0c-0.2,0-0.4,0-0.5-0.1c-0.1,0.1-0.1,0.2-0.2,0.2c-0.2,0.2-0.4,0.5-0.5,0.8 C25.9,39,25.9,39.2,25.9,39.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8985,
    y1: -135.955,
    x2: 35.6385,
    y2: -135.955,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M26.9,39.1c0,0.5,0.2,1,0.6,1.4c-0.2-0.2-0.3-0.5-0.2-0.8c0.1,0.4,0.9,1,1,1.1c0.3,0.3,0.9,0.8,0.9,1.3 c0.4-0.3,0.8-0.8,1-1.3c0.3-0.4,0.4-1,0.3-1.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.5,0.3,0.7c0-0.2,0.1-0.4,0.2-0.5 c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.4,0.1-0.8,0-1.2c0-0.1-0.1-0.2-0.1-0.2h-0.5l0,0c0,0.1,0,0.2,0,0.3l0,0c0,0,0,0.1,0,0.1l0,0 c0,0,0,0.1,0,0.1l0,0v0.2l0,0c0,0,0,0.1,0,0.1l0,0c0,0,0,0.1,0,0.1l0,0v0.1l0,0c0,0,0,0,0,0.1v-0.1l0,0c0,0,0-0.1,0-0.1l0,0 c0,0,0-0.1,0-0.1l0,0c0,0,0-0.1,0-0.1l0,0l-0.1-0.1l0,0l0,0h-0.2v0.1c0,0,0,0,0,0.1l0,0c0,0,0,0.1,0,0.1l0,0v0.1l0,0v0.1l0,0v0.1 v0.1l0,0v0.1l0,0c0,0,0,0,0,0.1l0,0c0,0,0,0,0,0.1V39c0,0,0,0,0,0.1l0,0c0,0,0,0.1,0,0.1c-0.1,0-0.2-0.1-0.3-0.1 c-0.1,0.4-0.2,0.9-0.4,1.3c-0.1-0.3-0.3-0.6-0.6-0.8c-0.3-0.3-1.2-0.6-1.1-1.1c-0.1,0.2-0.1,0.5,0,0.7l-0.1-0.1l0,0v0l0,0l0,0l0,0 l0,0l0,0v0l0,0l0,0l0,0c0,0,0,0,0-0.1v-0.3l0,0c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0-0.1l0,0c0,0,0,0,0-0.1l0,0c0,0,0,0,0-0.1l0,0v-0.1 v0v-0.1l0,0h-0.3C27.5,38.3,27.1,38.7,26.9,39.1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27,36.6L27,36.6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.1,36.6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27,36.6L27,36.6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.1,36.7L27.1,36.7z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.6,36.8L27.6,36.8L27.6,36.8z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.2,36.7L27.2,36.7z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.4,36.7L27.4,36.7z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.3,36.7L27.3,36.7z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.5,36.8L27.5,36.8z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M26.6,37.5c0,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0.1,0.5,0.1h0.2c0.1,0,0.3,0,0.4,0c0,0.1,0,0.2,0,0.3 c0,0,0.1,0.2,0.9,0.2l0,0c0.2,0,0.5,0,0.7-0.1c0.2,0.1,0.4,0.1,0.7,0.1l0,0h0.3h0.1c0.3-0.1,0.4-0.2,0.4-0.2l0,0 c0-0.1,0-0.2,0-0.3l0,0h0.4c0.3,0,0.5,0,0.8-0.2c0.1,0,0.1-0.1,0.1-0.1c0-0.3-0.1-0.7-0.1-1c0-0.1,0-0.1,0-0.2h0l0,0 c0.1,0.4,0.2,0.7,0.2,1.1c0,0-0.1,0.2-0.6,0.2l0,0c-0.2,0-0.4,0-0.5-0.1v0c0,0,0-0.1,0-0.2v-0.1h0c0,0.2,0.1,0.4,0.1,0.7 c0,0-0.1,0.2-0.6,0.2l0,0c-0.6,0-0.6-0.2-0.6-0.2s0-0.3,0-0.4h-0.3h-0.1c0,0.1,0,0.2,0,0.3c0,0.2,0,0.1,0,0.1l0,0 c0,0-0.2,0.2-0.6,0.2l0,0c-0.6,0-0.6-0.2-0.6-0.2c0-0.3,0.1-0.5,0.1-0.8v-0.1l0,0v0.2c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1l0,0 c-0.2,0.1-0.4,0.1-0.5,0.1l0,0c-0.6,0-0.6-0.2-0.6-0.2c0-0.3,0.1-0.7,0.2-1v-0.1v0.1C26.8,36.9,26.7,37.2,26.6,37.5z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.9,36.9L27.9,36.9z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.7,36.8L27.7,36.8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M28.1,36.9L28.1,36.9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M27.6,37.2c0,0.2-0.1,0.4-0.3,0.4l0,0c-0.2,0-0.4-0.1-0.5-0.3c0-0.2,0-0.4,0.1-0.6v-0.1c0,0-0.1-0.1-0.1-0.1 c-0.1,0.3-0.1,0.7-0.2,1c0,0,0.1,0.2,0.6,0.2l0,0c0.2,0,0.4,0,0.5-0.1l0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1v-0.2l0,0h-0.1 C27.7,37.2,27.7,37.2,27.6,37.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M26.9,36.7L26.9,36.7c-0.1,0.3-0.1,0.5-0.1,0.7c0,0.2,0.3,0.3,0.5,0.3l0,0c0.2,0,0.3-0.2,0.3-0.4 C27.3,37.1,27.1,36.9,26.9,36.7z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M28.9,37L28.9,37z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M29.1,37L29.1,37z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M29.5,37L29.5,37z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M28.4,36.9L28.4,36.9z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M28.6,36.9L28.6,36.9z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M29.1,37L29.1,37z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M28.2,36.9h-0.1H28.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M28.4,36.9h-0.1l0,0H28.4z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M28.8,37.6c0,0.2-0.1,0.5-0.3,0.5l0,0c-0.2,0-0.4-0.1-0.4-0.3c0-0.2,0-0.3,0-0.5l0-0.1 c0,0.2-0.1,0.5-0.1,0.8c0,0,0.1,0.2,0.6,0.2l0,0c0.5,0,0.6-0.1,0.6-0.2l0,0c0,0,0-0.1,0-0.1s0-0.2,0-0.3L28.8,37.6L28.8,37.6z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M28.1,37.3c0,0.2,0,0.3,0,0.5c0,0.2,0.2,0.3,0.4,0.3l0,0c0.2,0,0.3-0.2,0.3-0.5 C28.5,37.6,28.3,37.5,28.1,37.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.9,36.5L31.9,36.5z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.8,36.5L31.8,36.5z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.7,36.5L31.7,36.5z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.8,36.5L31.8,36.5z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.7,36.6L31.7,36.6z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31,36.8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.2,36.8L31.2,36.8z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.1,36.8L31.1,36.8z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.5,36.7L31.5,36.7z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.3,36.7L31.3,36.7z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.4,36.7L31.4,36.7z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M31.6,36.6L31.6,36.6z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M30.9,36.8L30.9,36.8z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M31.9,36.5c0,0.1,0,0.1,0,0.2v0.1c0.1,0.2,0.1,0.4,0.1,0.6c0,0.2-0.3,0.3-0.5,0.3l0,0 c-0.2,0-0.3-0.2-0.3-0.3l-0.4,0.1v0.1c0,0,0,0.1,0,0.2v0c0.2,0.1,0.4,0.1,0.5,0.1l0,0c0.6,0,0.6-0.2,0.6-0.2 C32,37.2,31.9,36.8,31.9,36.5L31.9,36.5L31.9,36.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M31.1,37.2c0,0.2,0.1,0.3,0.3,0.3l0,0c0.2,0,0.4-0.1,0.5-0.3c0-0.2,0-0.4-0.1-0.6v-0.1 C31.7,36.9,31.5,37.2,31.1,37.2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M30.4,36.9L30.4,36.9z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M30.2,36.9L30.2,36.9z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M29.7,37L29.7,37z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M30,36.9L30,36.9z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M29.9,36.9L29.9,36.9z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M30.7,36.9L30.7,36.9h-0.1H30.7L30.7,36.9z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M30.6,36.9L30.6,36.9L30.6,36.9z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M30.7,37.4c0,0.1,0,0.3,0,0.4c0,0.2-0.3,0.3-0.4,0.3l0,0c-0.2,0-0.3-0.2-0.3-0.4h-0.1h-0.3 c0,0.1,0,0.2,0,0.4s0.1,0.2,0.6,0.2l0,0c0.6,0,0.6-0.2,0.6-0.2C30.9,37.8,30.8,37.6,30.7,37.4L30.7,37.4L30.7,37.4z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M29.9,37.7c0,0.2,0.1,0.4,0.3,0.4l0,0c0.2,0,0.4-0.1,0.4-0.3c0-0.1,0-0.3,0-0.4 C30.5,37.6,30.2,37.7,29.9,37.7z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M26.9,36.7L26.9,36.7L26.9,36.7L26.9,36.7L26.9,36.7L26.9,36.7L26.9,36.7L26.9,36.7 C26.9,36.6,26.9,36.6,26.9,36.7z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M27.9,36.9L27.9,36.9h-0.1h-0.1V37c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.3,0H28C28,37.1,27.9,37,27.9,36.9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M26.9,36.7c0.2,0.2,0.4,0.4,0.7,0.5c0-0.1,0-0.2,0-0.2v-0.2h-0.1h-0.1l0,0h-0.1l0,0h0l0,0h0l0,0h-0.1l0,0 h-0.1l0,0l0,0l0,0L26.9,36.7z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M28.1,36.9h-0.2c0,0.1,0,0.2,0.1,0.4l0,0v0.1C28,37.2,28,37,28.1,36.9L28.1,36.9z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M29,37h-0.2c0,0.2,0,0.3,0,0.5c0,0.1,0,0.1,0,0.2l0,0h0.3C29.1,37.5,29,37.2,29,37z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M28.1,37.2c0-0.1,0.1-0.2,0.1-0.3h-0.1c0,0.1-0.1,0.2-0.1,0.4l0.1,0.1C28.1,37.3,28.1,37.3,28.1,37.2z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M28.2,36.9c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0.1,0,0.1c0.2,0.2,0.5,0.3,0.8,0.3c0-0.1,0-0.1,0-0.2 c0-0.2,0-0.3,0-0.5h-0.4L28.2,36.9z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M29.6,37H29c0.1,0.2,0.1,0.4,0.1,0.7h0.1h0.3c0-0.2,0.1-0.5,0.1-0.7L29.6,37z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M29.9,37.7c0-0.1,0-0.2,0-0.2c0-0.2,0-0.3,0-0.5h-0.2c-0.1,0.2-0.1,0.5-0.1,0.7h0.3L29.9,37.7z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M30.8,36.8h-0.2c0.1,0.2,0.1,0.3,0.1,0.5h0c0,0,0-0.1,0-0.1C30.8,37.1,30.8,37,30.8,36.8z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M31.8,36.7c0-0.1,0-0.1,0-0.2l0,0l0,0l0,0C31.8,36.6,31.8,36.6,31.8,36.7z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M31.1,37c0,0,0-0.1,0-0.2l0,0H31l0,0h-0.1l0,0c0,0.1-0.1,0.3-0.1,0.4c0,0,0,0.1,0,0.1l0.4-0.1 C31.1,37.2,31.1,37,31.1,37z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M31.1,37c0,0.1,0,0.2,0,0.3c0.3-0.1,0.6-0.3,0.7-0.6c0,0,0-0.1,0-0.1l0,0l0,0l0,0l0,0l0,0h0l0,0h-0.1l0,0 h-0.1l0,0h0l0,0h-0.1l0,0h-0.1l0,0C31.1,36.8,31.1,36.9,31.1,37z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M30.6,36.9L30.6,36.9l0,0.3c0,0,0,0.1,0,0.2h0.1l0,0C30.7,37.2,30.7,37.1,30.6,36.9L30.6,36.9z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M29.9,37.5c0,0.1,0,0.1,0,0.2c0.3,0,0.5-0.1,0.8-0.3c0-0.1,0-0.1,0-0.2l-0.1-0.3h-0.6 C29.9,37.1,29.9,37.3,29.9,37.5z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8,36.5L26.8,36.5L26.8,36.5L26.8,36.5L26.8,36.5L26.8,36.5L26.8,36.5L26.8,36.5L26.8,36.5L26.8,36.5 L26.8,36.5L26.8,36.5h0.1l0,0h0l0,0h0l0,0h0.1l0,0h0.1h0.1l0,0h0.1h0.1h0.2h0.1l0,0H28h2.1h0.1l0,0h0.1h0.1h0.1l0,0h0.1l0,0h0.1 l0,0h0.1l0,0h0l0,0h0.1l0,0H31l0,0h0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0l0-0.1L30.7,35l-0.4-0.3c-0.6,0.3-1.2,0.3-1.8,0.3 c-1.8,0-1.8-0.4-1.8-0.4L26.3,35c2.4,0.7,3.5,0.2,3.5,0.2c-1,0.6-3.4,0.2-3.4,0.2c-0.2,0.1-0.5,1-0.5,1l0.4-1.3l-0.4,1.3 c0,0,0.1,0.1,0.1,0.1L26.8,36.5z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.2,24.5l0.1-0.2L27.2,24.5z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.2,29.7c-0.1-1.3-0.1-2.7,0.1-4c0.1-0.3,0.1-0.5,0.2-0.8l0,0c-0.1,0-0.3-0.1-0.4-0.1 c0,0.1-0.1,0.2-0.1,0.3c-0.4,1.5-0.4,3.1-0.2,4.7l0.1-0.1L27.2,29.7z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.1,24.9c0-0.1,0.1-0.3,0.1-0.4C27.2,24.6,27.2,24.7,27.1,24.9z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M29.4,34.9c0.6,0.1,1.2,0,1.8-0.3c0.1,0,0.1-0.1,0.1-0.1s0-0.1,0-0.2l0,0c0.1-0.6,0.4-2,0.6-3.6l0.1-0.6 c0-0.1,0-0.1,0-0.2v-0.1l0,0c0.2-1.6,0.1-3.2-0.2-4.7c-0.4-1.5-1.1-2.8-2.2-3.9c-0.1-0.1-0.3-0.1-0.5,0c-0.8,0.8-1.5,1.9-1.9,3 l0.1-0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.2-0.7,0.6-1.4,1-2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.1,0.1c0.5,0.7,0.8,1.4,1,2.2 c0.5,0,1-0.2,1.4-0.5c0.1,0.2,0.2,0.5,0.3,0.8c-0.4,0.2-0.9,0.4-1.4,0.4l0,0c0,0.2,0.1,0.4,0.1,0.6c0.1,0.3,0.1,0.7,0.1,1h0.1 c0.8-0.1,1.6,0.5,1.7,1.3c0.1,0.8-0.5,1.6-1.3,1.7c-0.1,0-0.2,0-0.3,0l0,0c-0.1,2.4-0.5,4.7-0.5,4.7s0,0.3-1.2,0.3 c-0.9,0-1.1-0.2-1.2-0.3h-0.1l0,0C27.6,34.5,27.6,34.9,29.4,34.9z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.7,24.2L27.7,24.2c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.2l0,0l-0.1,0.2l0,0c0,0.1-0.1,0.3-0.1,0.4l0,0 c0.1,0.1,0.3,0.1,0.4,0.1C27.6,24.7,27.6,24.4,27.7,24.2z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.3,25.1c0.5,0,1-0.2,1.4-0.4c-0.1-0.3-0.2-0.5-0.3-0.8c-0.4,0.3-0.8,0.4-1.3,0.4l0,0 C30.1,24.6,30.2,24.9,30.3,25.1z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M30.5,29.7c-0.4,0-0.9-0.2-1.1-0.5c0,0.5-0.1,0.9-0.2,1.4c0,0.2-0.1,1.2-0.5,1.2h-0.1 c-0.1,0-0.1-0.1-0.2-0.1l0,0l0,0l0,0l0,0l0,0h-0.1l0,0l0,0l0,0l0,0c0,0,0,0,0-0.1c0,0,0,0,0,0l0,0l0,0h0.1 c-0.2-0.4-0.3-0.9-0.4-1.4c0-0.1,0-0.2,0-0.3l0,0l0,0l0,0l0,0c-0.3-1.6-0.4-3.2-0.2-4.8c-0.1,0-0.2,0-0.3,0 c-0.1,0.2-0.1,0.5-0.2,0.8c-0.2,1.3-0.3,2.7-0.1,4h0.1l0.6,4.7h-0.1c0,0.1,0.2,0.3,1.2,0.3c1.1,0,1.2-0.3,1.2-0.3s0.4-2.3,0.5-4.7 L30.5,29.7L30.5,29.7z M28.7,34.1L28.7,34.1L28.7,34.1L28.7,34.1c0,0.1,0,0.1,0,0.1l0,0h-0.1h-0.1l0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0-0.1l0,0H28.7L28.7,34.1z M28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9 L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9L28.4,32.9 L28.4,32.9z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M29.4,25.2h-0.4c0,0.3,0.1,0.5,0.1,0.8s0.1,0.8,0.1,1.3c0.3-0.3,0.7-0.5,1.1-0.5h0.1c0-0.3-0.1-0.7-0.1-1 c0-0.2-0.1-0.4-0.1-0.6C30,25.1,29.8,25.2,29.4,25.2z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.9,24.3c0-0.1,0-0.1,0-0.2c0-0.2,0.2-0.9,0.5-0.9h0.1c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2,0.1,0.4,0.1,0.6h0.5 c0.2,0,0.4,0,0.6,0l0,0c-0.2-0.8-0.5-1.5-1-2.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0.1c-0.4,0.6-0.8,1.3-1,2l0,0L27.9,24.3z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.8,25c0-0.3,0-0.5,0.1-0.8l-0.2,0c-0.1,0.2-0.1,0.5-0.2,0.8l0,0C27.6,25,27.7,25,27.8,25z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.4,24.4h-0.5c0,0.3,0.1,0.5,0.1,0.8h0.4c0.3,0,0.6,0,0.9,0l0,0c-0.1-0.3-0.1-0.5-0.2-0.7 C29.9,24.4,29.6,24.4,29.4,24.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "27.8,28.2 27.8,28.2 27.8,28.2 27.8,28.2 27.8,28.2  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "27.8,28.2 27.8,28.2 27.8,28.2 27.8,28.2  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "28.2,25.6 28.2,25.6 28.2,25.6  "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M28.9,24.4c0-0.2-0.1-0.4-0.1-0.6c0-0.2-0.1-0.4-0.2-0.6h-0.1c-0.3,0-0.5,0.7-0.5,0.9c0,0.1,0,0.1,0,0.2 C28.3,24.3,28.6,24.4,28.9,24.4z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "28.2,25.5 28.2,25.5 28.2,25.5  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "27.8,28.2 27.8,28.2 27.8,28.2  "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M27.8,25c-0.2,1.5-0.1,3.1,0.1,4.6l0,0l0,0l0,0H28l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0H28h-0.1l0,0l0,0 c0,0.1,0,0.2,0,0.3c0.1,0.4,0.2,0.9,0.3,1.3l0,0l0,0c0,0,0,0,0,0.1l0,0l0,0l0,0c0,0.1,0.1,0.1,0.2,0.1h0.1c0.4,0,0.4-0.9,0.5-1.2 c0.1-0.5,0.1-0.9,0.2-1.4c-0.2-0.3-0.4-0.6-0.4-1c0-0.4,0.1-0.7,0.4-1c0-0.4-0.1-0.9-0.1-1.3s-0.1-0.5-0.1-0.8 C28.5,24.9,28.2,25,27.8,25z M28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1C28,28.1,28,28.1,28.1,28.1l-0.1,0l0,0l0,0l0,0 l0,0c0,0,0,0,0-0.1l0,0l0,0l0,0h0L28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1z M28.1,26.9 c-0.1,0-0.1-0.1-0.1-0.2c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2,0.1,0.1,0.2C28.2,26.8,28.1,26.9,28.1,26.9L28.1,26.9L28.1,26.9z  M28.5,25.5L28.5,25.5L28.5,25.5L28.5,25.5L28.5,25.5L28.5,25.5C28.5,25.5,28.5,25.6,28.5,25.5l-0.1,0h0l0,0l0,0l0,0 c0,0,0,0,0-0.1l0,0l0,0l0,0L28.5,25.5L28.5,25.5L28.5,25.5L28.5,25.5L28.5,25.5C28.5,25.5,28.5,25.5,28.5,25.5L28.5,25.5z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.8,25c0.4,0.1,0.9,0.1,1.3,0.1c0-0.2-0.1-0.5-0.1-0.8c-0.3,0-0.7-0.1-1-0.1C27.9,24.5,27.8,24.8,27.8,25z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,35.3c0,0,2.5,0.4,3.4-0.2c0,0-1.1,0.5-3.5-0.2l0,0l0,0.2l-0.4,1.3C26.7,36.3,27,35.4,27.2,35.3z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.3,29.2c0.3,0.3,0.7,0.5,1.1,0.5h0.1c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h-0.1c-0.8,0-1.5,0.7-1.5,1.5 l0,0C28.9,28.6,29.1,28.9,29.3,29.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.14,
    y1: -124.2301,
    x2: 36.15,
    y2: -124.2301,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M29.1,28.2c0,0.8,0.6,1.5,1.4,1.5h0.1c0.8,0.1,1.6-0.5,1.7-1.3c0.1-0.8-0.5-1.6-1.3-1.7c-0.1,0-0.2,0-0.3,0 h-0.1C29.8,26.8,29.1,27.4,29.1,28.2z M30.3,29.2L30.3,29.2L30.3,29.2L30.3,29.2c-0.2,0-0.2-0.1-0.3-0.1l0,0L29.9,29l0,0l-0.1-0.1 l0,0l-0.1-0.1l0,0c0,0,0-0.1,0-0.1l0,0c0-0.1-0.1-0.2-0.1-0.4c0-0.6,0.4-1,0.9-1.1c0,0,0,0,0.1,0h0.1c0.6-0.1,1.1,0.4,1.2,1 c0.1,0.6-0.4,1.1-1,1.2c-0.1,0-0.1,0-0.2,0h-0.1C30.5,29.3,30.4,29.3,30.3,29.2L30.3,29.2z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,27.2L30.8,27.2L30.8,27.2L30.8,27.2h0.1l0,0l0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.1,0.1l0,0l0,0.1 l0,0c0,0.1,0.1,0.3,0.1,0.4c0,0.5-0.4,1-0.9,1.1h0c0.6,0.1,1.1-0.4,1.2-1c0.1-0.6-0.4-1.1-1-1.2c-0.1,0-0.1,0-0.2,0h0L30.8,27.2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M30,29.1L29.9,29L30,29.1z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M29.9,29l-0.1-0.1L29.9,29z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M29.7,28.7c0,0,0-0.1,0-0.1S29.7,28.7,29.7,28.7z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M29.8,28.9l-0.1-0.1L29.8,28.9z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M30.3,29.2L30.3,29.2L30.3,29.2z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M31.2,27.5L31.2,27.5z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M31.1,27.4L31.1,27.4z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M31.3,27.6L31.3,27.6z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M31.2,27.4L31.2,27.4z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M30.9,27.2L30.9,27.2z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M31.5,27.8l0-0.1L31.5,27.8z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M30.9,27.2L30.9,27.2z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M31,27.3L31,27.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,28.2c0-0.1,0-0.3-0.1-0.4c-0.3,0.5-0.7,1-1.1,1.4c0.1,0,0.2,0,0.2,0l0,0C31.1,29.2,31.5,28.8,31.5,28.2 z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.4,27.7l-0.1-0.1c-0.4,0.6-0.8,1.1-1.3,1.5c0.1,0.1,0.1,0.1,0.2,0.1C30.7,28.8,31.1,28.3,31.4,27.7z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8,27.2h-0.2l0,0c-0.6,0-1,0.4-1,1c0,0,0,0,0,0.1c0,0.1,0,0.2,0.1,0.4C30.1,28.2,30.4,27.7,30.8,27.2z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3,27.6L31.3,27.6L31.3,27.6L31.3,27.6L31.3,27.6L31.3,27.6L31.3,27.6L31.3,27.6L31.3,27.6L31,27.3l0,0 h-0.1l0,0l0,0h-0.1c-0.4,0.5-0.7,0.9-1.1,1.4l0,0c0,0,0,0.1,0,0.1l0,0l0.1,0.1l0,0l0.1,0.1l0,0l0.1,0.1l0,0 C30.5,28.7,31,28.1,31.3,27.6z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,27.9L31.5,27.9l0-0.1l0,0c-0.3,0.6-0.7,1.1-1.2,1.5l0,0h0.1l0,0C30.7,28.8,31.1,28.4,31.5,27.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.39,
    y1: -128.4375,
    x2: 31.26,
    y2: -128.4375,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M24.7,34.9c0.2-1.3,0.7-2.7,1.2-3.9c0.4-0.5,0.8-0.9,1.3-1.3h-0.3l-0.1,0.1l-0.3,0.3c0,0,0.1,0-0.2,0.3 c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,1-0.6,2-0.9,3c0,0.3-0.1,0.4-0.2,0.5l0,0c0,0.1,0.2,0.2,0.3,0.2l0.4-0.1 C24.6,35.2,24.7,34.9,24.7,34.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.6774,
    y1: -128.3992,
    x2: 31.83,
    y2: -128.3992,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M27.8,34.5c-1.5,0.3-1.8,0-1.8,0c-1-1.2,1.2-4.7,1.2-4.7c-0.5,0.4-0.9,0.8-1.3,1.3c-0.6,1.2-1,2.5-1.2,3.9 c0,0-0.1,0.3,0.4,0.2l0,0l0.4-0.1h0.2l1.9-0.4h0.1L27.8,34.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.8,
    y1: -128.1611,
    x2: 31.83,
    y2: -128.1611,
    gradientTransform: "matrix(1 0 0 -1 -4 -96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M26,34.5c0,0,0.3,0.3,1.8,0l-0.6-4.7C27.3,29.7,25.1,33.2,26,34.5z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.4,25.5L28.4,25.5L28.4,25.5L28.4,25.5h-0.1l0,0l0,0l0,0c0,0,0,0,0,0.1l0,0l0,0l0,0L28.4,25.5L28.4,25.5 C28.5,25.6,28.5,25.5,28.4,25.5L28.4,25.5L28.4,25.5L28.4,25.5L28.4,25.5L28.4,25.5C28.5,25.5,28.5,25.5,28.4,25.5L28.4,25.5z  M28.2,25.5L28.2,25.5z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28,26.6c-0.1,0-0.1,0.1-0.1,0.2c0,0,0.1,0.1,0.1,0.1C28.1,26.9,28.2,26.8,28,26.6 C28.1,26.7,28.1,26.6,28,26.6z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1L28,28h-0.1h0l0,0l0,0l0,0c0,0,0,0,0,0.1l0,0l0,0l0,0l0,0 L28.1,28.1C28,28.1,28,28.2,28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1L28.1,28.1z M27.8,28.2L27.8,28.2z  M27.8,28.2L27.8,28.2z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.8,28.2 27.8,28.2 27.8,28.2  "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,29.8L27.9,29.8L27.9,29.8h0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0H27.9L27.9,29.8L27.9,29.8 L27.9,29.8L27.9,29.8L27.9,29.8L27.9,29.8L27.9,29.8L27.9,29.8L27.9,29.8z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.4,31.5L28.4,31.5L28.4,31.5C28.4,31.5,28.4,31.5,28.4,31.5L28.4,31.5L28.4,31.5L28.4,31.5L28.4,31.5 L28.4,31.5C28.3,31.5,28.3,31.5,28.4,31.5C28.3,31.5,28.3,31.6,28.4,31.5L28.4,31.5L28.4,31.5L28.4,31.5L28.4,31.5L28.4,31.5 L28.4,31.5L28.4,31.5L28.4,31.5L28.4,31.5L28.4,31.5L28.4,31.5z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.4,33L28.4,33L28.4,33h0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0H28.4L28.4,33L28.4,33L28.4,33L28.4,33 L28.4,33L28.4,33L28.4,33z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,34.1L28.6,34.1L28.6,34.1C28.5,34.1,28.5,34.1,28.6,34.1L28.6,34.1c-0.1,0.1-0.1,0.1-0.1,0.1l0,0l0,0 h0.1h0.1l0,0C28.7,34.2,28.7,34.2,28.6,34.1L28.6,34.1L28.6,34.1L28.6,34.1L28.6,34.1L28.6,34.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21.639b6cedc8d02f6f2a53c940f3cad8fa.svg";
export { ForwardRef as ReactComponent };